import React, { memo } from "react";
import {
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
} from '@chakra-ui/react';
import { AccordionItemLink } from "../../molecules/SidebarAccordionItemLink";
import { AccordionList } from "../../molecules/SidebarAccordionPanelList";

export const BlocksReserveAccordionMenu: React.FC = memo(() => {
    return (
        <AccordionItem border='none'>
            <AccordionButton>
                <Box as="span" flex='1' textAlign='left' fontWeight='bold'>
                    Blocksリザーブ
                </Box>
                <AccordionIcon />
            </AccordionButton>
            <AccordionPanel>
                <AccordionList>
                    <AccordionItemLink to={`reserve/reserve`} text="予約情報" />
                    <AccordionItemLink to={`reserve/customer`} text="顧客管理" />
                    <AccordionItemLink to={`reserve/report`} text="レポート" />
                    <AccordionItemLink to={`reserve/settings`} text="営業設定" />
                    <AccordionItemLink to={`reserve/reserve_settings`} text="予約台帳設定" />
                    <AccordionItemLink to={`reserve/shop_settings`} text="店舗設定" />
                    <AccordionItemLink to={`reserve/other_settings`} text="外部連携設定" />
                </AccordionList>
            </AccordionPanel>
        </AccordionItem>
    );
});